import * as e from "react";
import { cloneElement as t, forwardRef as n, memo as r, useContext as i, useEffect as a, useImperativeHandle as o, useLayoutEffect as s, useMemo as c, useRef as l, useState as u } from "react";
import { createPortal as d } from "react-dom";
//#region node_modules/@vis.gl/react-maplibre/dist/components/use-map.js
var f = e.createContext(null);
function p() {
	let e = i(f)?.maps, t = i(M);
	return c(() => ({
		...e,
		current: t?.map
	}), [e, t]);
}
//#endregion
//#region node_modules/@vis.gl/react-maplibre/dist/utils/deep-equal.js
function m(e, t) {
	let n = Array.isArray(e) ? e[0] : e ? e.x : 0, r = Array.isArray(e) ? e[1] : e ? e.y : 0, i = Array.isArray(t) ? t[0] : t ? t.x : 0, a = Array.isArray(t) ? t[1] : t ? t.y : 0;
	return n === i && r === a;
}
function h(e, t) {
	if (e === t) return !0;
	if (!e || !t) return !1;
	if (Array.isArray(e)) {
		if (!Array.isArray(t) || e.length !== t.length) return !1;
		for (let n = 0; n < e.length; n++) if (!h(e[n], t[n])) return !1;
		return !0;
	} else if (Array.isArray(t)) return !1;
	if (typeof e == "object" && typeof t == "object") {
		let n = Object.keys(e), r = Object.keys(t);
		if (n.length !== r.length) return !1;
		for (let r of n) if (!t.hasOwnProperty(r) || !h(e[r], t[r])) return !1;
		return !0;
	}
	return !1;
}
//#endregion
//#region node_modules/@vis.gl/react-maplibre/dist/utils/transform.js
function g(e) {
	return {
		longitude: e.center.lng,
		latitude: e.center.lat,
		zoom: e.zoom,
		pitch: e.pitch,
		bearing: e.bearing,
		padding: e.padding
	};
}
function _(e, t) {
	let n = t.viewState || t, r = {};
	if ("longitude" in n && "latitude" in n && (n.longitude !== e.center.lng || n.latitude !== e.center.lat)) {
		let t = e.center.constructor;
		r.center = new t(n.longitude, n.latitude);
	}
	return "zoom" in n && n.zoom !== e.zoom && (r.zoom = n.zoom), "bearing" in n && n.bearing !== e.bearing && (r.bearing = n.bearing), "pitch" in n && n.pitch !== e.pitch && (r.pitch = n.pitch), n.padding && e.padding && !h(n.padding, e.padding) && (r.padding = n.padding), r;
}
//#endregion
//#region node_modules/@vis.gl/react-maplibre/dist/utils/style-utils.js
var v = [
	"type",
	"source",
	"source-layer",
	"minzoom",
	"maxzoom",
	"filter",
	"layout"
];
function y(e) {
	if (!e) return null;
	if (typeof e == "string" || ("toJS" in e && (e = e.toJS()), !e.layers)) return e;
	let t = {};
	for (let n of e.layers) t[n.id] = n;
	let n = e.layers.map((e) => {
		let n = null;
		"interactive" in e && (n = Object.assign({}, e), delete n.interactive);
		let r = t[e.ref];
		if (r) {
			n ||= Object.assign({}, e), delete n.ref;
			for (let e of v) e in r && (n[e] = r[e]);
		}
		return n || e;
	});
	return {
		...e,
		layers: n
	};
}
//#endregion
//#region node_modules/@vis.gl/react-maplibre/dist/maplibre/maplibre.js
var b = {
	version: 8,
	sources: {},
	layers: []
}, x = {
	mousedown: "onMouseDown",
	mouseup: "onMouseUp",
	mouseover: "onMouseOver",
	mousemove: "onMouseMove",
	click: "onClick",
	dblclick: "onDblClick",
	mouseenter: "onMouseEnter",
	mouseleave: "onMouseLeave",
	mouseout: "onMouseOut",
	contextmenu: "onContextMenu",
	touchstart: "onTouchStart",
	touchend: "onTouchEnd",
	touchmove: "onTouchMove",
	touchcancel: "onTouchCancel"
}, S = {
	movestart: "onMoveStart",
	move: "onMove",
	moveend: "onMoveEnd",
	dragstart: "onDragStart",
	drag: "onDrag",
	dragend: "onDragEnd",
	zoomstart: "onZoomStart",
	zoom: "onZoom",
	zoomend: "onZoomEnd",
	rotatestart: "onRotateStart",
	rotate: "onRotate",
	rotateend: "onRotateEnd",
	pitchstart: "onPitchStart",
	pitch: "onPitch",
	pitchend: "onPitchEnd"
}, C = {
	wheel: "onWheel",
	boxzoomstart: "onBoxZoomStart",
	boxzoomend: "onBoxZoomEnd",
	boxzoomcancel: "onBoxZoomCancel",
	resize: "onResize",
	load: "onLoad",
	render: "onRender",
	idle: "onIdle",
	remove: "onRemove",
	data: "onData",
	styledata: "onStyleData",
	sourcedata: "onSourceData",
	error: "onError"
}, w = [
	"minZoom",
	"maxZoom",
	"minPitch",
	"maxPitch",
	"maxBounds",
	"projection",
	"renderWorldCopies"
], T = [
	"scrollZoom",
	"boxZoom",
	"dragRotate",
	"dragPan",
	"keyboard",
	"doubleClickZoom",
	"touchZoomRotate",
	"touchPitch"
], E = class e {
	constructor(e, t, n) {
		this._map = null, this._internalUpdate = !1, this._hoveredFeatures = null, this._propsedCameraUpdate = null, this._styleComponents = {}, this._onEvent = (e) => {
			let t = this.props[C[e.type]];
			t ? t(e) : e.type === "error" && console.error(e.error);
		}, this._onCameraEvent = (e) => {
			if (this._internalUpdate) return;
			e.viewState = this._propsedCameraUpdate || g(this._map.transform);
			let t = this.props[S[e.type]];
			t && t(e);
		}, this._onCameraUpdate = (e) => this._internalUpdate ? e : (this._propsedCameraUpdate = g(e), _(e, this.props)), this._onPointerEvent = (e) => {
			(e.type === "mousemove" || e.type === "mouseout") && this._updateHover(e);
			let t = this.props[x[e.type]];
			t && (this.props.interactiveLayerIds && e.type !== "mouseover" && e.type !== "mouseout" && (e.features = this._hoveredFeatures || this._queryRenderedFeatures(e.point)), t(e), delete e.features);
		}, this._MapClass = e, this.props = t, this._initialize(n);
	}
	get map() {
		return this._map;
	}
	setProps(e) {
		let t = this.props;
		this.props = e;
		let n = this._updateSettings(e, t), r = this._updateSize(e), i = this._updateViewState(e);
		this._updateStyle(e, t), this._updateStyleComponents(e), this._updateHandlers(e, t), (n || r || i && !this._map.isMoving()) && this.redraw();
	}
	static reuse(t, n) {
		let r = e.savedMaps.pop();
		if (!r) return null;
		let i = r.map, a = i.getContainer();
		for (n.className = a.className; a.childNodes.length > 0;) n.appendChild(a.childNodes[0]);
		i._container = n;
		let o = i._resizeObserver;
		o && (o.disconnect(), o.observe(n)), r.setProps({
			...t,
			styleDiffing: !1
		}), i.resize();
		let { initialViewState: s } = t;
		return s && (s.bounds ? i.fitBounds(s.bounds, {
			...s.fitBoundsOptions,
			duration: 0
		}) : r._updateViewState(s)), i.isStyleLoaded() ? i.fire("load") : i.once("style.load", () => i.fire("load")), i._update(), r;
	}
	_initialize(e) {
		let { props: t } = this, { mapStyle: n = b } = t, r = {
			...t,
			...t.initialViewState,
			container: e,
			style: y(n)
		}, i = r.initialViewState || r.viewState || r;
		if (Object.assign(r, {
			center: [i.longitude || 0, i.latitude || 0],
			zoom: i.zoom || 0,
			pitch: i.pitch || 0,
			bearing: i.bearing || 0
		}), t.gl) {
			let e = HTMLCanvasElement.prototype.getContext;
			HTMLCanvasElement.prototype.getContext = () => (HTMLCanvasElement.prototype.getContext = e, t.gl);
		}
		let a = new this._MapClass(r);
		i.padding && a.setPadding(i.padding), t.cursor && (a.getCanvas().style.cursor = t.cursor), a.transformCameraUpdate = this._onCameraUpdate, a.on("style.load", () => {
			this._styleComponents = {
				light: a.getLight(),
				sky: a.getSky(),
				projection: a.getProjection?.(),
				terrain: a.getTerrain()
			}, this._updateStyleComponents(this.props);
		}), a.on("sourcedata", () => {
			this._updateStyleComponents(this.props);
		});
		for (let e in x) a.on(e, this._onPointerEvent);
		for (let e in S) a.on(e, this._onCameraEvent);
		for (let e in C) a.on(e, this._onEvent);
		this._map = a;
	}
	recycle() {
		this.map.getContainer().querySelector("[mapboxgl-children]")?.remove(), e.savedMaps.push(this);
	}
	destroy() {
		this._map.remove();
	}
	redraw() {
		let e = this._map;
		e.style && (e._frame &&= (e._frame.cancel(), null), e._render());
	}
	_updateSize(e) {
		let { viewState: t } = e;
		if (t) {
			let e = this._map;
			if (t.width !== e.transform.width || t.height !== e.transform.height) return e.resize(), !0;
		}
		return !1;
	}
	_updateViewState(e) {
		let t = this._map, n = t.transform;
		if (!t.isMoving()) {
			let r = _(n, e);
			if (Object.keys(r).length > 0) return this._internalUpdate = !0, t.jumpTo(r), this._internalUpdate = !1, !0;
		}
		return !1;
	}
	_updateSettings(e, t) {
		let n = this._map, r = !1;
		for (let i of w) i in e && !h(e[i], t[i]) && (r = !0, n[`set${i[0].toUpperCase()}${i.slice(1)}`]?.call(n, e[i]));
		return r;
	}
	_updateStyle(e, t) {
		if (e.cursor !== t.cursor && (this._map.getCanvas().style.cursor = e.cursor || ""), e.mapStyle !== t.mapStyle) {
			let { mapStyle: t = b, styleDiffing: n = !0 } = e, r = { diff: n };
			"localIdeographFontFamily" in e && (r.localIdeographFontFamily = e.localIdeographFontFamily), this._map.setStyle(y(t), r);
		}
	}
	_updateStyleComponents({ light: e, projection: t, sky: n, terrain: r }) {
		let i = this._map, a = this._styleComponents;
		i.style._loaded && (e && !h(e, a.light) && (a.light = e, i.setLight(e)), t && !h(t, a.projection) && t !== a.projection?.type && (a.projection = typeof t == "string" ? { type: t } : t, i.setProjection?.(a.projection)), n && !h(n, a.sky) && (a.sky = n, i.setSky(n)), r !== void 0 && !h(r, a.terrain) && (!r || i.getSource(r.source)) && (a.terrain = r, i.setTerrain(r)));
	}
	_updateHandlers(e, t) {
		let n = this._map;
		for (let r of T) {
			let i = e[r] ?? !0;
			h(i, t[r] ?? !0) || (i ? n[r].enable(i) : n[r].disable());
		}
	}
	_queryRenderedFeatures(e) {
		let t = this._map, { interactiveLayerIds: n = [] } = this.props;
		try {
			return t.queryRenderedFeatures(e, { layers: n.filter(t.getLayer.bind(t)) });
		} catch {
			return [];
		}
	}
	_updateHover(e) {
		let { props: t } = this;
		if (t.interactiveLayerIds && (t.onMouseMove || t.onMouseEnter || t.onMouseLeave)) {
			let t = e.type, n = this._hoveredFeatures?.length > 0, r = this._queryRenderedFeatures(e.point), i = r.length > 0;
			!i && n && (e.type = "mouseleave", this._onPointerEvent(e)), this._hoveredFeatures = r, i && !n && (e.type = "mouseenter", this._onPointerEvent(e)), e.type = t;
		} else this._hoveredFeatures = null;
	}
};
E.savedMaps = [];
//#endregion
//#region node_modules/@vis.gl/react-maplibre/dist/maplibre/create-ref.js
var D = [
	"setMaxBounds",
	"setMinZoom",
	"setMaxZoom",
	"setMinPitch",
	"setMaxPitch",
	"setRenderWorldCopies",
	"setProjection",
	"setStyle",
	"addSource",
	"removeSource",
	"addLayer",
	"removeLayer",
	"setLayerZoomRange",
	"setFilter",
	"setPaintProperty",
	"setLayoutProperty",
	"setLight",
	"setTerrain",
	"setFog",
	"remove"
];
function O(e) {
	if (!e) return null;
	let t = e.map, n = { getMap: () => t };
	for (let e of k(t)) !(e in n) && !D.includes(e) && (n[e] = t[e].bind(t));
	return n;
}
function k(e) {
	let t = /* @__PURE__ */ new Set(), n = e;
	for (; n;) {
		for (let r of Object.getOwnPropertyNames(n)) r[0] !== "_" && typeof e[r] == "function" && r !== "fire" && r !== "setEventedParent" && t.add(r);
		n = Object.getPrototypeOf(n);
	}
	return Array.from(t);
}
//#endregion
//#region node_modules/@vis.gl/react-maplibre/dist/utils/use-isomorphic-layout-effect.js
var A = typeof document < "u" ? s : a;
//#endregion
//#region node_modules/@vis.gl/react-maplibre/dist/utils/set-globals.js
function j(e, t) {
	let { RTLTextPlugin: n, maxParallelImageRequests: r, workerCount: i, workerUrl: a } = t;
	if (n && e.getRTLTextPluginStatus && e.getRTLTextPluginStatus() === "unavailable") {
		let { pluginUrl: t, lazy: r = !0 } = typeof n == "string" ? { pluginUrl: n } : n;
		e.setRTLTextPlugin(t, (e) => {
			e && console.error(e);
		}, r);
	}
	r !== void 0 && e.setMaxParallelImageRequests(r), i !== void 0 && e.setWorkerCount(i), a !== void 0 && e.setWorkerUrl(a);
}
//#endregion
//#region node_modules/@vis.gl/react-maplibre/dist/components/map.js
var M = e.createContext(null);
function N(t, n) {
	let r = i(f), [s, d] = u(null), p = l(), { current: m } = l({
		mapLib: null,
		map: null
	});
	a(() => {
		let e = t.mapLib, n = !0, i;
		return Promise.resolve(e || import("maplibre-gl")).then((e) => {
			if (!n) return;
			if (!e) throw Error("Invalid mapLib");
			let a = "Map" in e ? e : e.default;
			if (!a.Map) throw Error("Invalid mapLib");
			j(a, t), t.reuseMaps && (i = E.reuse(t, p.current)), i ||= new E(a.Map, t, p.current), m.map = O(i), m.mapLib = a, d(i), r?.onMapMount(m.map, t.id);
		}).catch((e) => {
			let { onError: n } = t;
			n ? n({
				type: "error",
				target: null,
				originalEvent: null,
				error: e
			}) : console.error(e);
		}), () => {
			n = !1, i && (r?.onMapUnmount(t.id), t.reuseMaps ? i.recycle() : i.destroy());
		};
	}, []), A(() => {
		s && s.setProps(t);
	}), o(n, () => m.map, [s]);
	let h = c(() => ({
		position: "relative",
		width: "100%",
		height: "100%",
		...t.style
	}), [t.style]);
	return e.createElement("div", {
		id: t.id,
		ref: p,
		style: h
	}, s && e.createElement(M.Provider, { value: m }, e.createElement("div", {
		"mapboxgl-children": "",
		style: { height: "100%" }
	}, t.children)));
}
var P = e.forwardRef(N), F = /box|flex|grid|column|lineHeight|fontWeight|opacity|order|tabSize|zIndex/;
function I(e, t) {
	if (!e || !t) return;
	let n = e.style;
	for (let e in t) {
		let r = t[e];
		Number.isFinite(r) && !F.test(e) ? n[e] = `${r}px` : n[e] = r;
	}
}
//#endregion
//#region node_modules/@vis.gl/react-maplibre/dist/utils/compare-class-names.js
function L(e, t) {
	if (e === t) return null;
	let n = R(e), r = R(t), i = [];
	for (let e of r) n.has(e) || i.push(e);
	for (let e of n) r.has(e) || i.push(e);
	return i.length === 0 ? null : i;
}
function R(e) {
	return new Set(e ? e.trim().split(/\s+/) : []);
}
//#endregion
//#region node_modules/@vis.gl/react-maplibre/dist/components/marker.js
var z = r(n((t, n) => {
	let { map: r, mapLib: s } = i(M), u = l({ props: t }), f = c(() => {
		let n = !1;
		e.Children.forEach(t.children, (e) => {
			e && (n = !0);
		});
		let r = {
			...t,
			element: n ? document.createElement("div") : void 0
		}, i = new s.Marker(r);
		return i.setLngLat([t.longitude, t.latitude]), i.getElement().addEventListener("click", (e) => {
			u.current.props.onClick?.({
				type: "click",
				target: i,
				originalEvent: e
			});
		}), i.on("dragstart", (e) => {
			let t = e;
			t.lngLat = f.getLngLat(), u.current.props.onDragStart?.(t);
		}), i.on("drag", (e) => {
			let t = e;
			t.lngLat = f.getLngLat(), u.current.props.onDrag?.(t);
		}), i.on("dragend", (e) => {
			let t = e;
			t.lngLat = f.getLngLat(), u.current.props.onDragEnd?.(t);
		}), i;
	}, []);
	a(() => (f.addTo(r.getMap()), () => {
		f.remove();
	}), []);
	let { longitude: p, latitude: h, offset: g, style: _, draggable: v = !1, popup: y = null, rotation: b = 0, rotationAlignment: x = "auto", pitchAlignment: S = "auto" } = t;
	a(() => {
		I(f.getElement(), _);
	}, [_]), o(n, () => f, []);
	let C = u.current.props;
	(f.getLngLat().lng !== p || f.getLngLat().lat !== h) && f.setLngLat([p, h]), g && !m(f.getOffset(), g) && f.setOffset(g), f.isDraggable() !== v && f.setDraggable(v), f.getRotation() !== b && f.setRotation(b), f.getRotationAlignment() !== x && f.setRotationAlignment(x), f.getPitchAlignment() !== S && f.setPitchAlignment(S), f.getPopup() !== y && f.setPopup(y);
	let w = L(C.className, t.className);
	if (w) for (let e of w) f.toggleClassName(e);
	return u.current.props = t, d(t.children, f.getElement());
})), B = r(n((e, t) => {
	let { map: n, mapLib: r } = i(M), s = c(() => document.createElement("div"), []), u = l({ props: e }), f = c(() => {
		let t = { ...e }, n = new r.Popup(t);
		return n.setLngLat([e.longitude, e.latitude]), n.once("open", (e) => {
			u.current.props.onOpen?.(e);
		}), n;
	}, []);
	if (a(() => {
		let e = (e) => {
			u.current.props.onClose?.(e);
		};
		return f.on("close", e), f.setDOMContent(s).addTo(n.getMap()), () => {
			f.off("close", e), f.isOpen() && f.remove();
		};
	}, []), a(() => {
		I(f.getElement(), e.style);
	}, [e.style]), o(t, () => f, []), f.isOpen()) {
		let t = u.current.props;
		(f.getLngLat().lng !== e.longitude || f.getLngLat().lat !== e.latitude) && f.setLngLat([e.longitude, e.latitude]), e.offset && !h(t.offset, e.offset) && f.setOffset(e.offset), (t.anchor !== e.anchor || t.maxWidth !== e.maxWidth) && (f.options.anchor = e.anchor, f.setMaxWidth(e.maxWidth));
		let n = L(t.className, e.className);
		if (n) for (let e of n) f.toggleClassName(e);
		u.current.props = e;
	}
	return d(e.children, s);
}));
//#endregion
//#region node_modules/@vis.gl/react-maplibre/dist/components/use-control.js
function V(e, t, n, r) {
	let o = i(M), s = c(() => e(o), []);
	return a(() => {
		let e = r || n || t, i = typeof t == "function" && typeof n == "function" ? t : null, a = typeof n == "function" ? n : typeof t == "function" ? t : null, { map: c } = o;
		return c.hasControl(s) || (c.addControl(s, e?.position), i && i(o)), () => {
			a && a(o), c.hasControl(s) && c.removeControl(s);
		};
	}, []), s;
}
//#endregion
//#region node_modules/@vis.gl/react-maplibre/dist/components/attribution-control.js
function H(e) {
	let t = V(({ mapLib: t }) => new t.AttributionControl(e), { position: e.position });
	return a(() => {
		I(t._container, e.style);
	}, [e.style]), null;
}
r(H);
//#endregion
//#region node_modules/@vis.gl/react-maplibre/dist/components/fullscreen-control.js
function U(e) {
	let t = V(({ mapLib: t }) => new t.FullscreenControl({ container: e.containerId && document.getElementById(e.containerId) }), { position: e.position });
	return a(() => {
		I(t._controlContainer, e.style);
	}, [e.style]), null;
}
r(U);
//#endregion
//#region node_modules/@vis.gl/react-maplibre/dist/components/geolocate-control.js
function W(e, t) {
	let n = l({ props: e }), r = V(({ mapLib: t }) => {
		let r = new t.GeolocateControl(e), i = r._setupUI;
		return r._setupUI = () => {
			r._container.hasChildNodes() || i();
		}, r.on("geolocate", (e) => {
			n.current.props.onGeolocate?.(e);
		}), r.on("error", (e) => {
			n.current.props.onError?.(e);
		}), r.on("outofmaxbounds", (e) => {
			n.current.props.onOutOfMaxBounds?.(e);
		}), r.on("trackuserlocationstart", (e) => {
			n.current.props.onTrackUserLocationStart?.(e);
		}), r.on("trackuserlocationend", (e) => {
			n.current.props.onTrackUserLocationEnd?.(e);
		}), r;
	}, { position: e.position });
	return n.current.props = e, o(t, () => r, []), a(() => {
		I(r._container, e.style);
	}, [e.style]), null;
}
r(n(W));
//#endregion
//#region node_modules/@vis.gl/react-maplibre/dist/components/navigation-control.js
function G(e) {
	let t = V(({ mapLib: t }) => new t.NavigationControl(e), { position: e.position });
	return a(() => {
		I(t._container, e.style);
	}, [e.style]), null;
}
var K = r(G);
//#endregion
//#region node_modules/@vis.gl/react-maplibre/dist/components/scale-control.js
function q(e) {
	let t = V(({ mapLib: t }) => new t.ScaleControl(e), { position: e.position }), n = l(e), r = n.current;
	n.current = e;
	let { style: i } = e;
	return e.maxWidth !== void 0 && e.maxWidth !== r.maxWidth && (t.options.maxWidth = e.maxWidth), e.unit !== void 0 && e.unit !== r.unit && t.setUnit(e.unit), a(() => {
		I(t._container, i);
	}, [i]), null;
}
r(q);
//#endregion
//#region node_modules/@vis.gl/react-maplibre/dist/components/terrain-control.js
function J(e) {
	let t = V(({ mapLib: t }) => new t.TerrainControl(e), { position: e.position });
	return a(() => {
		I(t._container, e.style);
	}, [e.style]), null;
}
r(J);
//#endregion
//#region node_modules/@vis.gl/react-maplibre/dist/components/logo-control.js
function Y(e) {
	let t = V(({ mapLib: t }) => new t.LogoControl(e), { position: e.position });
	return a(() => {
		I(t._container, e.style);
	}, [e.style]), null;
}
r(Y);
//#endregion
//#region node_modules/@vis.gl/react-maplibre/dist/utils/assert.js
function X(e, t) {
	if (!e) throw Error(t);
}
//#endregion
//#region node_modules/@vis.gl/react-maplibre/dist/components/source.js
var Z = 0;
function Q(e, t, n) {
	if (e.style && e.style._loaded) {
		let r = { ...n };
		return delete r.id, delete r.children, e.addSource(t, r), e.getSource(t);
	}
	return null;
}
function $(e, t, n) {
	X(t.id === n.id, "source id changed"), X(t.type === n.type, "source type changed");
	let r = "", i = 0;
	for (let e in t) e !== "children" && e !== "id" && !h(n[e], t[e]) && (r = e, i++);
	if (!i) return;
	let a = t.type;
	if (a === "geojson") e.setData(t.data);
	else if (a === "image") e.updateImage({
		url: t.url,
		coordinates: t.coordinates
	});
	else switch (r) {
		case "coordinates":
			e.setCoordinates?.(t.coordinates);
			break;
		case "url":
			e.setUrl?.(t.url);
			break;
		case "tiles":
			e.setTiles?.(t.tiles);
			break;
		default: console.warn(`Unable to update <Source> prop: ${r}`);
	}
}
function ee(n) {
	let r = i(M).map.getMap(), o = l(n), [, s] = u(0), d = c(() => n.id || `jsx-source-${Z++}`, []);
	a(() => {
		if (r) {
			let e = () => setTimeout(() => s((e) => e + 1), 0);
			return r.on("styledata", e), e(), () => {
				if (r.off("styledata", e), r.style && r.style._loaded && r.getSource(d)) {
					let e = r.getStyle()?.layers;
					if (e) for (let t of e) t.source === d && r.removeLayer(t.id);
					r.removeSource(d);
				}
			};
		}
	}, [r]);
	let f = r && r.style && r.getSource(d);
	return f ? $(f, n, o.current) : f = Q(r, d, n), o.current = n, f && e.Children.map(n.children, (e) => e && t(e, { source: d })) || null;
}
//#endregion
//#region node_modules/@vis.gl/react-maplibre/dist/components/layer.js
function te(e, t, n, r) {
	if (X(n.id === r.id, "layer id changed"), X(n.type === r.type, "layer type changed"), n.type === "custom" || r.type === "custom") return;
	let { layout: i = {}, paint: a = {}, filter: o, minzoom: s, maxzoom: c, beforeId: l } = n;
	if (l !== r.beforeId && e.moveLayer(t, l), i !== r.layout) {
		let n = r.layout || {};
		for (let r in i) h(i[r], n[r]) || e.setLayoutProperty(t, r, i[r]);
		for (let r in n) i.hasOwnProperty(r) || e.setLayoutProperty(t, r, void 0);
	}
	if (a !== r.paint) {
		let n = r.paint || {};
		for (let r in a) h(a[r], n[r]) || e.setPaintProperty(t, r, a[r]);
		for (let r in n) a.hasOwnProperty(r) || e.setPaintProperty(t, r, void 0);
	}
	h(o, r.filter) || e.setFilter(t, o), (s !== r.minzoom || c !== r.maxzoom) && e.setLayerZoomRange(t, s, c);
}
function ne(e, t, n) {
	if (e.style && e.style._loaded && (!("source" in n) || e.getSource(n.source))) {
		let r = {
			...n,
			id: t
		};
		delete r.beforeId, e.addLayer(r, n.beforeId);
	}
}
var re = 0;
function ie(e) {
	let t = i(M).map.getMap(), n = l(e), [, r] = u(0), o = c(() => e.id || `jsx-layer-${re++}`, []);
	if (a(() => {
		if (t) {
			let e = () => r((e) => e + 1);
			return t.on("styledata", e), e(), () => {
				t.off("styledata", e), t.style && t.style._loaded && t.getLayer(o) && t.removeLayer(o);
			};
		}
	}, [t]), t && t.style && t.getLayer(o)) try {
		te(t, o, e, n.current);
	} catch (e) {
		console.warn(e);
	}
	else ne(t, o, e);
	return n.current = e, null;
}
//#endregion
export { z as a, B as i, ee as n, P as o, K as r, p as s, ie as t };
